/*
 _______________________________________________________
/ This code was generated by a tool.                    \
|                                                       |
| Changes to this file may cause incorrect behavior and |
\  will be lost if the code is regenerated.             /
 -------------------------------------------------------
       \   ,__,
        \  (oo)____
           (__)    )\
              ||--|| *
*/
enum TermsOfUseAliases {
  BUTTON_CONFIRM = 'button-confirm',
  CHECKBOX_AGREE = 'checkbox-agree',
  FETCH_TERMS_OF_USE = 'fetch-terms-of-use',
  FIELD_CHECKBOX = 'field-checkbox',
  HTML_VIEWER_TERM = 'html-viewer-term',
  LAYOUT_ACTIONS = 'layout-actions',
  LAYOUT_GENERAL = 'layout-general',
  MAPPER_0 = 'mapper-0',
  MODAL_CONTENT = 'modal-content',
  PANEL_ACTIONS = 'panel-actions',
  PANEL_BUTTON = 'panel-button',
  PANEL_CHECK_BOX = 'panel-check-box',
  PANEL_GENERAL = 'panel-general',
  PANEL_SUBTITLE = 'panel-subtitle',
  TEXT_SUBTITLE = 'text-subtitle',
}
export { TermsOfUseAliases };
